import { useFormatPrice } from '@/hooks/use-brand';
import { type Rates } from '@/types';
import { useTranslation } from 'react-i18next';

export function PricingCard({ rates }: { rates: Rates }) {
  const { t } = useTranslation('common');
  const formatPrice = useFormatPrice();

  const sections = (Object.keys(rates) as Array<keyof Rates>).filter(
    (k) => rates[k].length > 0,
  );

  if (sections.length === 0) return null;

  const sectionLabel: Record<keyof Rates, string> = {
    in_call: t('pricing.in_call'),
    out_call: t('pricing.out_call'),
    video_call: t('pricing.video_call'),
  };

  return (
    <div className="rounded-xl border border-border bg-card">
      <div
        className="grid divide-x divide-border"
        style={{ gridTemplateColumns: `repeat(${sections.length}, 1fr)` }}
      >
        {sections.map((s) => (
          <div key={s} className="px-4 py-3">
            <p className="mb-2 text-xs font-semibold tracking-wide text-muted-foreground uppercase">
              {sectionLabel[s]}
            </p>
            <div className="space-y-1">
              {rates[s].map((rate, i) => (
                <div
                  key={i}
                  className="flex items-baseline justify-between gap-2"
                >
                  <span className="text-xs whitespace-nowrap text-muted-foreground">
                    {rate.formatted_duration}
                  </span>
                  <span className="text-sm font-semibold tabular-nums">
                    {formatPrice(Number(rate.price))}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
